var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPayId(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "31px",
    viewBox: "0 0 30 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPayID") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alternative-payment-options",
    transform: "translate(-40.000000, -459.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-transfer",
    transform: "translate(12.210526, 438.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PayID_logo_header-01",
    transform: "translate(0.000000, 21.842105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8561156,0 L34.5279181,0 C30.8078513,0 27.7894737,3.03508446 27.7894737,6.7829961 L27.7894737,23.2170039 C27.7894737,26.9649155 30.8078513,30 34.5279181,30 L50.8561156,30 C54.5761824,30 57.59456,26.9649155 57.59456,23.2170039 L57.59456,6.77742714 C57.59456,3.03508446 54.5761824,0 50.8561156,0 Z M41.2663625,7.18953035 C41.338759,7.18396139 43.0428615,6.97790978 45.0198431,7.39558196 C47.7542036,7.97475404 49.6866335,9.45052905 50.6166502,11.6669761 L48.8401512,12.418786 C47.5759968,9.39483943 43.9895851,9.05513273 42.3467412,9.06627065 L42.3467412,18.0601448 L40.4198802,18.0601448 L40.4198802,7.29534063 L41.2663625,7.18953035 Z M34.3385734,8.52608131 C34.3385734,7.72415073 34.984573,7.0781511 35.7809346,7.0781511 C36.5772962,7.0781511 37.2232958,7.72415073 37.2232958,8.52608131 C37.2232958,9.32801188 36.5772962,9.97401151 35.7809346,9.97401151 C34.984573,9.97401151 34.3385734,9.32801188 34.3385734,8.52608131 Z M51.090012,16.7792835 C50.9842017,17.4642658 50.8282708,18.0824206 50.6277881,18.5613514 C49.324651,21.6465565 46.2784286,23.2114349 41.5837933,23.2114349 L34.7451076,23.2114349 L34.7451076,12.5078894 L36.6719686,12.5078894 L36.6719686,21.273436 L41.5782244,21.273436 C45.4263773,21.273436 47.8767208,20.103954 48.8457202,17.8039725 C48.9570994,17.5366623 49.0573408,17.1802487 49.1297373,16.7792835 L47.5314451,16.7792835 L50.2825125,13.304251 L53.0391488,16.7848524 L51.090012,16.7792835 Z",
    id: "icPayID"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayId);
export default __webpack_public_path__ + "static/media/icPayID.d6bc206730d1b13da9c82ca910313b68.svg";
export { ForwardRef as ReactComponent };